import { CommentGateway } from './comment-gateway.interface';

export const initCommentAPI = (apiSlice: any, gateway: CommentGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Comment'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getCommentByProjectAndSlug: builder.query({
          query: gateway.getCommentByProjectAndSlug,
          providesTags: ['Comment'],
        }),
        patchComment: builder.mutation({
          query: gateway.patchComment,
          invalidatesTags: ['Comment'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface CommentSliceType {
  useGetCommentByProjectAndSlugQuery: Function;
  useLazyGetCommentByProjectAndSlugQuery: Function;
  usePatchCommentMutation: Function;
}
